import { Action } from '@/_core/fluxstore/types';
import { BoardActivityPanelState } from '../types';
import { useBoardActivityStore } from '../useModule';
import { incrementQueryId } from '../staleGuard';

const { registerReducer } = useBoardActivityStore();

export class SetBoardActivityPanelOpen extends Action<BoardActivityPanelState> {
    public static ACTION_TYPE = 'BoardActivity::SetPanelOpen';

    constructor(public isOpen: boolean) {
        super(SetBoardActivityPanelOpen.ACTION_TYPE);
    }
}

const reducer = (state: BoardActivityPanelState, action: SetBoardActivityPanelOpen): void => {
    if (action.isOpen) {
        state.isPanelOpen = true;
        state.unseenCount = 0;
        state.realtimeCountedActivityIds = [];
        state.realtimeAddedActivityIds = [];
        state.latestFollowedActivityId = null;
    } else {
        state.isPanelOpen = false;
        state.isFollowChangesOn = false;
        state.activities = [];
        state.realtimeAddedActivityIds = [];
        state.latestFollowedActivityId = null;
        state.totalCount = 0;
        state.error = null;
        state.isLoading = false;
        incrementQueryId(); // close-time invalidation
    }
};

//@ts-ignore
registerReducer(SetBoardActivityPanelOpen.ACTION_TYPE, reducer);
